import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrImageOwnerKind.ts
var t = () => e("imageOwnerKind");
//#endregion
export { t as useTrImageOwnerKind };
